module.exports = __webpack_public_path__ + "static/media/profile-picture-256w.1418f1cc.webp";